// src/components/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import TaskCard from './TaskCard';
import InstituteBanner from './InstituteBanner';
import { baseUrl } from '../config';



const Dashboard = () => {
  const [tasks, setTasks] = useState([]);
  // PLAN S11a: authoritative per GET /free-tier/status (same check the
  // backend's own gate uses, R2 - never role/user_type). null = still
  // checking; true redirects to the new Student Portal below. Login itself
  // is untouched: route_login.py (never-touch) already sends every student
  // with a completed profile to this same /dashboard route, same as
  // everyone else, so the split happens here, not at login.
  const [isVerifiedStudent, setIsVerifiedStudent] = useState(null);

  useEffect(() => {
    // Placeholder for API call to fetch tasks
    // Example:
    // fetch('/api/tasks')
    //   .then((response) => response.json())
    //   .then((data) => setTasks(data))
    //   .catch((error) => console.error('Error fetching tasks:', error));
    
    // For now, we can set dummy data to test the layout
    const dummyTasks = [
      {
        id: 1,
        title: 'Task 1',
        description: 'Lorem ipsum dolor sit amet consectetur.',
        dueDate: '12/3/25',
        assignedTo: 'John Doe',
        completionPercentage: 75,
      },
      {
        id: 2,
        title: 'Task 2',
        description: 'Lorem ipsum dolor sit amet consectetur.',
        dueDate: '12/3/25',
        assignedTo: 'Jane Doe',
        completionPercentage: 50,
      },
    ];
    setTasks(dummyTasks);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) { setIsVerifiedStudent(false); return; }
    (async () => {
      try {
        const res = await fetch(`${baseUrl}/free-tier/status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) { setIsVerifiedStudent(false); return; }
        const status = await res.json();
        setIsVerifiedStudent(status.state !== 'not_student');
      } catch (_) {
        // Fail safe to the regular dashboard - never blocks on this check.
        setIsVerifiedStudent(false);
      }
    })();
  }, []);

  if (isVerifiedStudent) {
    return <Navigate to="/my-producer-buddy-studentportal" replace />;
  }

  return (
    <div className="dashboard-container">
      <InstituteBanner />
      <div className="sort-search">
        <select className="sort-dropdown">
          <option>Last Week</option>
          <option>Last Month</option>
        </select>
        <input className="search-bar" type="text" placeholder="Search" />
      </div>
      <h1 className="recent-tasks-title">Recent Tasks</h1>
      <div className="task-cards-container">
        {tasks.map((task) => (
          <TaskCard key={task.id} task={task} />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;

